import {
	Department,
	useDeleteDepartmentMutation,
	useGetAllDepartmentsLazyQuery,
	PageInfo,
} from "@repo/server-api";
import { useState } from "react";

import { DataSource } from "@repo/legacy/components/shared/lists/DataSource";
import { PaginationModel } from "@repo/legacy/components/shared/lists/PaginationModel";

export function useAllDepartmentsDataSource(): DataSource<Department> {
	const [rows, setRows] = useState<Department[]>([]);
	const [rowCount, setRowCount] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [, setPageInfo] = useState<PageInfo | null>(null);
	const [searchBy, setSearchBy] = useState<string>("");
	const [pageModal, setPageModal] = useState<PaginationModel>({
		page: 0,
		pageSize: 10,
	});
	const [contactId, setContactId] = useState<string>("");

	const [deleteDepartment] = useDeleteDepartmentMutation({
		onCompleted(data) {
			if (data.deleteDepartment.boolean) {
				refresh();
			}
		},
	});

	const [getDepartments] = useGetAllDepartmentsLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data) {
			setIsLoading(false);
			if (data && data.allDepartments) {
				setRows(data.allDepartments.nodes as Department[]);
				setRowCount(data.allDepartments.totalCount);
				setPageInfo(data.allDepartments.pageInfo);
				setIsLoading(false);
			}
		},
	});

	const refresh = () => {
		fetchDataForContact(pageModal, searchBy, contactId);
	};

	const fetchDataForContact = (page: PaginationModel, searchBy: string, cId: string) => {
		setIsLoading(true);
		setSearchBy(searchBy);
		setPageModal(page);
		if (cId) setContactId(cId);
		if (cId !== "") {
			getDepartments({
				variables: {
					companyId: cId,
					first: page.pageSize,
					after: (page.pageSize * page.page).toString(),
					name: searchBy,
				},
			}).then((response) => {
				if (response.data && response.data.allDepartments) {
					setRows(response.data.allDepartments.nodes as Department[]);
					setRowCount(response.data.allDepartments.totalCount);
					setPageInfo(response.data.allDepartments.pageInfo);
					setIsLoading(false);
				}
			});
		}
	};

	const deleteData = (id: string) => {
		deleteDepartment({ variables: { id } });
	};

	return {
		rows,
		rowCount,
		isLoading,
		fetchDataForContact,
		deleteData,
		refresh,
	};
}
